import { render, staticRenderFns } from "./BienList.vue?vue&type=template&id=31ff4518"
import script from "./BienList.vue?vue&type=script&lang=js"
export * from "./BienList.vue?vue&type=script&lang=js"
import style0 from "./BienList.vue?vue&type=style&index=0&id=31ff4518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports